import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const archivedProjectDirectLinkRoute: InvariantJiraRoute = {
	name: 'archived-project-direct-link',
	path: '/jira/errors/project-archived',
	exact: true,
};
